.section {
  margin-bottom: 32px;
}

.sectionTitle {
  padding-bottom: 8px;
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 500;
  color: var(--ant-color-text-heading);
  border-bottom: 1px solid var(--ant-color-border-secondary);
}

.infoGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
}

.premium {
  color: var(--ant-color-warning);
}
